<mat-tab-group fxFlexFill *ngIf="reportNames$ | async as reportNames">
    <mat-tab *ngFor="let reportName of reportNames" [label]="reportName">
        <ng-template matTabContent>
            <pbi-report fxFlexFill [name]="reportName"></pbi-report>
        </ng-template>
    </mat-tab>
</mat-tab-group>
